import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ICampusItem } from '../../../models/campuses.model'
import { doGetCampuses } from '../../../store/campus.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';
import _ from 'lodash';
import { useSnackbar } from 'notistack';
import { Select, Table, TableColumnsType } from 'antd';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Pagination from '../../../components/Pagination';
import Footer from '../../../components/layout/Footer';
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import DownloadButton from '../../../components/DownloadButton';
import config from '../../../lib/config';
import exportTable from '../../../lib/exportTable';
import { errorVariant, warningVariant } from '../../../lib/barVariant';
import moment from 'moment';
import { addHyphen } from '../../../lib/util';
import useAuth from '../../../hooks/useAuth';
const { Option } = Select;

const BusinessCampus: FC = () => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // CA0001 = 학원상태
  const CA0001 = commonCodes.find(item => item.commonCode === 'CA0001')?.detailCode;
  // SY0004 = 지역코드
  const SY0004 = commonCodes.find(item => item.commonCode === 'SY0004')?.detailCode;

  const { campuses, isLoading } = useSelector((state: RootState) => state.campus);
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { enqueueSnackbar } = useSnackbar();

  const [campusData, setCampusData] = useState<ICampusItem[]>([]);
  const [page, setPage] = useState(1);
  const [region, setRegion] = useState('all');
  const [regionList, setRegionList] = useState<any>([]);
  const [field, setField] = useState('agent');
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('all');
  const [statusList, setStatusList] = useState<any>([]);
  const [includeTestCampus, setIncludeTestCampus] = useState(true);
  const [param, setParam] = useState({});
  const [exportTableLoading, setExportTableLoading] = useState<any>(false);

  useEffect(() => {
    if (CA0001) {
      const _statusList = [{ label: t('common.text.all'), value: 'all' }];
      const _CA0001 = [...CA0001].sort((a, b) => a.orderSeq < b.orderSeq ? -1 : (a.orderSeq > b.orderSeq ? 1 : 0));
      _CA0001.forEach((item: any) => {
        _statusList.push({
          label: item.korName,
          value: item.detailCode
        });
      });
      setStatusList(_statusList);
    }

    if (SY0004) {
      const _regionList: any = [{ label: t('common.text.all'), value: 'all' }];
      SY0004.forEach((item: any) => {
        _regionList.push({
          label: item.korName,
          value: item.detailCode
        });
      });
      setRegionList(_regionList);
    }
  }, [commonCodes]);

  useEffect(() => {
    // query to state
      const _param: any = {};

    if (query.page) {
      setPage(Number(query.page));
      _param.page = Number(query.page);
    }
    if (query.region) {
      setRegion(String(query.region));
      _param.region = String(query.region);
    }
    if (query.field) {
      setField(String(query.field));
      _param.field = String(query.field);
    }
    if (query.keyword) {
      setKeyword(String(query.keyword));
      _param.keyword = String(query.keyword);
    }
    if (query.status) {
      setStatus(String(query.status));
      _param.status = String(query.status);
    }
    if (query.includeTest) {
      setIncludeTestCampus(query.includeTest === 'true');
      _param.includeTest = query.includeTest === 'true';
    }

    // data filtering
    if (campuses) {
      let data: ICampusItem[] = _.cloneDeep(campuses);

      // 본사 데이터 제거
      // data = data.filter(item => item.campusCode !== 'CB00000001');

      // 연락처 뒷자리 마스킹
      // data.forEach(item => {
      //   if (item.mobilePhone) {
      //     const phone = item.mobilePhone.slice(0, -4) + '****';
      //     item.mobilePhone = phone;
      //   }
      // });

      if (query.region) {
        data = data.filter(item => item.sidoCode === query.region);
      }
      if (query.field && query.keyword) {
        if (query.field === 'agent') {
          // TODO: 추후 i18n 적용 시 managerKorName과 managerEngName 분기
          data = data.filter(item => item.managerKorName !== null && item.managerKorName?.indexOf(String(query.keyword)) !== -1);
        } else if (query.field === 'campus') {
          // TODO: 추후 i18n 적용 시 campusKorName과 campusEngName 분기
          data = data.filter(item => item.campusKorName !== null && item.campusKorName?.indexOf(String(query.keyword)) !== -1);
        }
      }
      if (query.status) {
        data = data.filter(item => item.campusStatus === query.status);
      }
      if (query.includeTest && query.includeTest === 'false') {
        data = data.filter(item => item.testYn === 'N');
      }

      setCampusData(data);
    }
  }, [location, campuses]);

  useEffect(() => {
    getCampuses();
  }, []);

  const getCampuses = async () => {
    const res = await dispatch(doGetCampuses());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      case 404:
        enqueueSnackbar(t('common.message.notFound'), {
          variant: 'warning'
        });
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSearch = () => {
    const param: any = { page: 1 };

    if (region !== 'all') {
      param.region = region;
    }
    if (field && keyword) {
      param.field = field;
      param.keyword = keyword;
    }
    if (status !== 'all') {
      param.status = status;
    }
    if (!includeTestCampus) {
      param.includeTest = false;
    }

    setParam(param);
    history.push(`/business/campus?${qs.stringify(param)}`);
  }

  const onExportTable = () => {
    setExportTableLoading(true);
    const data = _.cloneDeep(campusData);
    data.forEach(campus => {
      // 지역 열 변환
      const region = SY0004?.find((item: any) => item.detailCode === campus.sidoCode);
      campus.sidoCode = region?.korName || campus.sidoCode;
      // 상태 열 변환
      const status = statusList?.find((item: any) => item.value === campus.campusStatus);
      campus.campusStatus = status?.label || campus.campusStatus;
    });
    const currentDate = moment(new Date());
    exportTable(columns.slice(0, -1), data, `${t('business.campus.5')}_(${currentDate.format('YYYYMMDD')})`, t('business.campus.5'), [20, 15, 15, 15, 20, 20, 40, 10, 10]);
    setExportTableLoading(false);
  }
  
  const fieldList = [
    { label: t('business.campus.column1'), value: 'agent' },
    { label: t('business.campus.column2'), value: 'campus' }
  ];

  const columns: TableColumnsType<ICampusItem> = [
    {
      title: t('business.campus.column3'),
      dataIndex: 'campusCode',
      key: 'campusCode',
      width: '10%',
      sorter: (a, b) => a.campusCode?.localeCompare(b.campusCode)
    },
    {
      title: t('business.campus.column4'),
      dataIndex: 'sidoCode',
      key: 'sidoCode',
      width: '10%',
      sorter: (a, b) => a.sidoCode?.localeCompare(b.sidoCode),
      render: (sidoCode: string) => {
        const region = SY0004?.find((item: any) => item.detailCode === sidoCode);
        return region?.korName || sidoCode;
      }
    },
    {
      title: t('business.campus.column2'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      width: '10%',
      sorter: (a, b) => a.campusKorName?.localeCompare(b.campusKorName),
      render: (value: any, record: any) => (
        record.testYn === 'Y'
          ? `${t('business.campus.6')}${record.campusKorName}`
          : record.campusKorName
      )
    },
    {
      title: t('business.campus.column5'),
      dataIndex: 'representName',
      key: 'representName',
      width: '10%',
      sorter: (a, b) => a.representName?.localeCompare(b.representName)
    },
    {
      title: t('business.campus.column6'),
      dataIndex: 'telephoneNo',
      key: 'telephoneNo',
      width: '10%',
      sorter: (a, b) => a.telephoneNo?.localeCompare(b.telephoneNo) || 1,
      render: value => value ? addHyphen(value) : '',
    },
    {
      title: t('business.campus.column7'),
      dataIndex: 'mobilePhone',
      key: 'mobilePhone',
      width: '10%',
      sorter: (a, b) => a.mobilePhone?.localeCompare(b.mobilePhone),
      render: value => value ? addHyphen(value) : '',
    },
    {
      title: t('common.text.address1'),
      key: 'address',
      dataIndex: 'address',
      align: 'center',
      render: value => <div className="text-left ant-table-cell-ellipsis">{value}</div>
    },
    {
      title: t('business.campus.column1'),
      key: 'managerKorName',
      dataIndex: 'managerKorName',
      width: '10%',
    },
    {
      title: t('common.column.status'),
      key: 'campusStatus',
      dataIndex: 'campusStatus',
      width: '6%',
      sorter: (a, b) => a.campusStatus?.localeCompare(b.campusStatus),
      render: (campusStatus: string) => {
        const status = statusList?.find((item: any) => item.value === campusStatus);
        return status?.label || campusStatus;
      }
    },
    {
      title: t('business.campus.column8'),
      key: 'contractDate',
      dataIndex: 'contractDate',
      width: '10%',
      sorter: (a, b) => a.contractDate?.localeCompare(b.contractDate),
      render: (value: string) => moment(value).format('YYYY.MM.DD')
    },
  ];

  return (
    <>
    <SimpleHeader
      iconFile="icon-business-big.svg"
      parentMenu={t('common.menu.business')}
      currentMenu={t('business.campus.title1')}
      onlyTitle={true}
    />
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('business.campus.column4')}</label>
            <div>
              <Select
                value={region}
                onChange={value => setRegion(value)}
              >
                {
                  regionList?.map((item: any) => {
                    return (
                      <Option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Option>
                    )
                  })
                }
              </Select>
            </div>
          </li>
          <li>
            <div>
              <Select
                value={field}
                onChange={value => setField(value)}
              >
                {
                  fieldList?.map((item: any) => {
                    return (
                      <Option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Option>
                    )
                  })
                }
              </Select>
            </div>
            <input
              type="text"
              className="form-control w-150p"
              onChange={(e => setKeyword(e.target.value))}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
            
          </li>
          <li>
            <label>{t('common.column.status')}</label>
            <div>
              <Select
                value={status}
                onChange={value => setStatus(value)}
              >
                {
                  statusList?.map((item: any) => {
                    return (
                      <Option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Option>
                    )
                  })
                }
              </Select>                    
            </div>
            <div className='comm-btn__area'>
              <Button
                className='btn-basic small black'
                onClick={onSearch}
                text={t('common.button.search')}
              />
              <label className="col-form-label">
                  {t('business.campus.column9')}
                </label>
                <div className="v-line">
                  <Checkbox
                    checked={includeTestCampus}
                    onChange={() => setIncludeTestCampus(!includeTestCampus)}
                    text={t('business.campus.option1')}
                  />
                </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div className="content scrollbar">
      {isLoading || exportTableLoading ? <Loader /> : null}

      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result">
            {t('common.text.count')}: <b>{campusData.length}</b>{t('common.text.unit')}
          </div>
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push(`/business/campus/create?${qs.stringify(param)}`)}
              text={t('business.campus.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={campusData || undefined}
            pagination={{
              current: page,
              pageSize: config.pageSize
            }}
            onRow={record => {
              return {
                onClick: () => {
                  history.push(`/business/campus/${record.campusCode}/edit?${qs.stringify(param)}`);
                }
              };
            }}
            rowClassName="pointer"
          />
        </div>
        <div className="comm-bx__between">
          <DownloadButton
            onClick={onExportTable}
          />
          <div className="common-paging center">
            <Pagination
              count={campusData?.length || 0}
              page={page}
              param={param}
              path="/business/campus"
            />
          </div>
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push(`/business/campus/create?${qs.stringify(param)}`)}
              text={t('business.campus.button1')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
    </>
  )
}

export default BusinessCampus;
